var React = require('react');

function ArrowRightLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.8039 9.68601L13.1917 17.7617C13.0403 17.9223 12.7925 18.0003 12.6273 18.0003C12.4444 18.0003 12.2608 17.9372 12.1152 17.8096C11.8045 17.5371 11.7814 17.0727 12.0639 16.7731L18.5189 9.92462H1.20623C0.785423 9.92462 0.445007 9.59632 0.445007 9.23177C0.445007 8.86721 0.785515 8.45632 1.20623 8.45632H18.5184L12.0625 1.60579C11.78 1.30612 11.803 0.841348 12.1138 0.569254C12.4253 0.298265 12.9062 0.318315 13.1898 0.619455L20.802 8.6951C21.0654 8.97481 21.0654 9.40613 20.8039 9.68601Z","fill":"currentColor"}));
}

ArrowRightLight.defaultProps = {"width":"21","height":"18","viewBox":"0 0 21 18","fill":"none"};

module.exports = ArrowRightLight;

ArrowRightLight.default = ArrowRightLight;
